import { createRoute, redirect } from "@tanstack/react-router";
import { CaseSourcePanel } from "@/components/case/case-source-panel";
import { useCaseDetail } from "@/hooks/use-case-detail";
import { caseLayoutRoute } from "./case-layout-route";

export const caseSourceRoute = createRoute({
  getParentRoute: () => caseLayoutRoute,
  path: "/source",
  component: CaseSourcePage,
});

/** Legacy path: Upload tab renamed to Source. */
export const caseUploadRedirectRoute = createRoute({
  getParentRoute: () => caseLayoutRoute,
  path: "/upload",
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/cases/$caseId/source",
      params: { caseId: params.caseId },
    });
  },
});

function CaseSourcePage() {
  const { caseId } = caseSourceRoute.useParams();
  const detailQuery = useCaseDetail(caseId);

  if (!detailQuery.data) return null;

  return <CaseSourcePanel caseId={caseId} detail={detailQuery.data} />;
}
